import { render, staticRenderFns } from "./FootPC.vue?vue&type=template&id=23074446&scoped=true&lang=pug&"
import script from "./FootPC.vue?vue&type=script&lang=js&"
export * from "./FootPC.vue?vue&type=script&lang=js&"
import style0 from "./FootPC.vue?vue&type=style&index=0&id=23074446&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23074446",
  null
  
)

export default component.exports